import { DynamicModalLayerInstance } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer';
import { DynamicModalMap } from './DynamicModal.constants';
import { DYNAMIC_MODAL_TYPES } from './DynamicModal.types';

export const isPopupModal = (dynamicModalView: DynamicModalLayerInstance['dynamicModalView']): boolean => {
  return DynamicModalMap[dynamicModalView].type === DYNAMIC_MODAL_TYPES.Popup;
};
